export default __webpack_public_path__ + "static/media/list-builder-save-icon.58a8cfdb.svg";